import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteWarehouseStockApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteWarehouseStock = createAsyncThunk('deleteWarehouseStock', async (payload) => {
  return await deleteWarehouseStockApi(payload);
});

const deleteWarehouseStockSlice = createSlice({
  name: 'deleteWarehouseStock', // Unique Name
  initialState,
  reducers: {
    deleteWarehouseStockReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteWarehouseStock.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteWarehouseStock.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteWarehouseStock.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteWarehouseStockReset } = deleteWarehouseStockSlice.actions;

export default deleteWarehouseStockSlice.reducer;
